import { useEffect, useState } from "react";

import { ALL_METRICS } from "../constants";
import { typedObjectKeys } from "../helpers/utils";

import type { Metrics } from "../types";

export default function useSelectedMetric(
  functionParam:
    | { localStorageKey: string; hiddenMetrics?: never }
    | { localStorageKey?: never; hiddenMetrics: (keyof Metrics)[] },
) {
  const [selectedMetric, setSelectedMetric] = useState<keyof Metrics>(() => {
    if ("localStorageKey" in functionParam) {
      const savedValue = localStorage.getItem(
        functionParam.localStorageKey,
      ) as keyof Metrics;
      if (savedValue) {
        return savedValue;
      }
    }
    if ("hiddenMetrics" in functionParam) {
      return typedObjectKeys(ALL_METRICS).filter(
        (key) => !functionParam.hiddenMetrics.includes(key),
      )[0];
    }
    return typedObjectKeys(ALL_METRICS)[0];
  });

  useEffect(() => {
    if ("localStorageKey" in functionParam) {
      localStorage.setItem(functionParam.localStorageKey, selectedMetric);
    }
  }, [selectedMetric]);

  return {
    selectedMetric,
    setSelectedMetric,
  };
}
